import { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const usePmCode = (param: CodeReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [pmCodeList, setPmCodeList] = useState<UserCodeListDto[] | any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.refcode.pmlist, {...param}],
    () => fetcher.refcode.getPmList(param),
    {
      onSuccess: (res: UserCodeListResDto) => {
        switch (res.code) {
          case 200:
            setPmCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, pmCodeList };
};

export default usePmCode;
